const moveOptionAvis = setInterval(function() {
  let beforeElementClass = 'main#MainContent section:nth-of-type(2) product-form form gp-product-variants';
  let optionContainerClass = '#avpoptions-container__v2';

  if (window.matchMedia("(max-width: 767px)").matches) {
    let optionContainer = document.querySelector(optionContainerClass);
    if (optionContainer && beforeElementClass) {
      let beforeElement = document.querySelector(beforeElementClass);
      beforeElement.insertAdjacentElement('afterend', optionContainer);
      clearInterval(moveOptionAvis); // Dừng setInterval sau khi đã thực hiện xong
    }
  }
}, 100);